import { ProgramAnswer } from './program-answer';

export class ProgramLog {
  public to: string;
  public at: string;
  public results?: ProgramAnswer[];
  public valid?: boolean;
}
